
<template>
  <div style="display: inline-block;">
    <div v-if="dragging" class="overlay-dropzone" @drop.stop.prevent="onDrop" @dragover.stop.prevent="onDragOver" @dragenter.stop.prevent="onDragEnter" @dragleave.stop.prevent="onDragLeave">
      <i class="fas fa-upload"/>
    </div>
    <div class="input-group" v-if="!flags.legacy">
      <input v-if="controlStyle === 'combo'" class="form-control" name="filename" placeholder="Upload PDF File" type="text" @focus="startBrowsing">
      <span :class="'input-group-btn controlStyle-' + controlStyle">
        <label :class="`btn browse-button ${btnClass}`" for="file">
          <WaveSpinner v-if="busy" inline :color="waveColor" />
          <span v-else><slot>Browse…</slot></span>
          <input class="file-upload" ref="file" id="file" style="display: none" type="file" @change="onFileSelected">
        </label>
      </span>
    </div>
    <b-button disabled v-else :class="btnClass" title="Upload not possible on IE">Upload</b-button>
    <slot  v-if="error" name="error"><div class="error">{{error}}</div></slot>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors.scss';

input.form-control {
  border-radius: 0;
  box-shadow: none;
}

.form-control {
  height: 48px;
}

// Hack to get the text in the button to center
.btn.browse-button {
  padding-top: 15px;
  padding-bottom: 15px;
}

.browse-button {
  cursor: pointer;
}

.btn {
  height: 48px;
  margin-bottom: 0;
}

.controlStyle-link {
  width: 100%;
  background-color: transparent;
  color: $gray-0;
  .btn {
    width: 100%;
  }
}

.overlay-dropzone {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
  background-color: rgba(0,0,0,0.5);
  text-align: center;
  color: white;
  font-size: 30vh;
  line-height: 100vh;
}

.error {
  text-align: center;
  margin: 0.25em auto;
  width: fit-content;
  padding: 0 0.5em;
  font-size: .875rem;
  color: #dc3545;
}

</style>

<script>
import { upload } from "@/services/design";
import { mapActions, mapGetters } from "vuex";
import { fontsMissingWarning } from "@/lib/track/events";
export default {
  props: {
    extra: {},
    controlStyle: {
      default: 'combo'
    },
    allowDrag: {
      default: true
    },
    variant: {
      default: 'default'
    }
  },
  data() {
    return {
      busy: false,
      error: null,
      dragging: false
    };
  },
  computed: {
    ...mapGetters(['flags']),
    validUploadTypeText() { return 'PDF'; },
    btnClass() {
      return this.controlStyle == 'link' ? '' : 'btn-' + this.variant;
    },
    waveColor() {
      return (this.controlStyle === 'link' || this.variant === "primary") ? 'red' : 'white';
    }
  },
  methods: {
    ...mapActions(["setDesign"]),
    startBrowsing() {
      this.error = null;
      this.$refs.file.click();
    },
    onFileSelected(evt) {
      try {
        this.uploadFile(evt.target.files[0]);
      } finally {
        // Clear the input so the user can upload again
        evt.target.value = '';
      }
    },
    async uploadFile(file) {
      this.busy = true;
      try {
        var design = await upload(file, this.extra);
        let doDefault = true;
        let event = {
          design,
          preventDefault() {
            doDefault = false;
          }
        };
        if (design.missingFonts) {
          fontsMissingWarning(design.missingFonts.join(', '))
        }
        this.$emit("upload", event);
        if (doDefault) {
          this.setDesign(design);
          this.$router.push({ name: "Editor", params: { id: design.id } });
        } else {
          this.busy = false;
        }
      } catch (e) {
        if (e == null) {
          // It's possible for e to be null/undefined. Ensure we don't pass undefined,
          // which causes wierdness. TODO how?
          e = null;
        } else {
          // Stringify
          e = ''+e;
        }
        if (e === 'Invalid file type.') {
          // Rewrite to be friendlier and more useful.
          e = `Please upload a ${this.validUploadTypeText} file`;
        }
        this.error = e;
        this.$emit("error", this.error);
        this.busy = false;
      }
    },
    onDrop(evt) {
      console.log(evt, evt.dataTransfer.files);
      this.uploadFile(evt.dataTransfer.files[0]);
      this.dragging = false;
    },
    onDragOver(evt) {},
    onDragEnter(evt) {
      if (this.allowDrag) this.dragging = true;
    },
    onDragLeave(evt) {
      this.dragging = false;
    }
  },
  mounted() {
    document.body.addEventListener('dragenter', this.onDragEnter);
  },
  beforeDestroy() {
    document.body.removeEventListener('dragenter', this.onDragEnter);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/PdfUploader.vue